import React, { useState, useEffect } from "react";
import "./../Spinner/loader.css";
import { connect } from "react-redux";
import { onChangeLevel2Dropdown } from "../actions";
import axios from "axios";
import LabelField from "./LabelField";

const Level2Dropdown = (props) => {
  const [parseBaseUrl] = useState(localStorage.getItem("baseUrl"));
  const [parseAppId] = useState(localStorage.getItem("parseAppId"));
  const [isLoading, setIsLoading] = useState(false);
  const [toastColor, setToastColor] = useState("#d9534f");
  const [toastDescription, setToastDescription] = useState("");
  const [state, setState] = useState({ [`${props.schema.parent}_DD`]: [] });
  const [parentId, setParentId] = useState("");
  const [propsId, setPropsId] = useState("");

  const getParams = (offset) => {
    const params = {
      skip: offset,
    };
    return params;
  };

  const Level1DropdownData = async (id) => {
    if (id) {
      setIsLoading(true);
      let response = [];
      if (props.schema.parent) {
        let reg = /(\#.*?\#)/gi;
        let _query = props.schema.data.query.replace(reg, id);
        try {
          let url = `${parseBaseUrl}classes/${props.schema.data.class}?${_query}`;
          const headers = {
            "Content-Type": "application/json",
            "X-Parse-Application-Id": parseAppId,
            "X-Parse-Session-Token": localStorage.getItem("accesstoken"),
          };

          await axios
            .get(url, { headers: headers })
            .then((res) => {
              let temp = [];
              res.data.results.forEach((x) => {
                let opt = "";
                if (Array.isArray(x[props.schema.data.valueKey])) {
                  x[props.schema.data.valueKey].forEach((tt) => {
                    if (typeof tt === "object") {
                      opt = {
                        objectId: tt[props.schema.data.displayKey],
                        option: tt[props.schema.data.displayKey],
                      };
                    } else {
                      opt = {
                        objectId: tt,
                        option: tt,
                      };
                    }
                    temp.push(opt);
                  });
                } else if (props.schema.data.isPointer) {
                  if (props.schema.data.valueKey.includes(".")) {
                    let newArr = props.schema.data.valueKey.split(".");
                    if (newArr.length === 2) {
                      let _dis = props.schema.data.displayKey.split(".");
                      if (_dis.length === 2) {
                        if (x[newArr[0]]) {
                          opt = {
                            objectId: x[newArr[0]][newArr[1]],
                            option: x[_dis[0]][_dis[1]],
                          };
                        }
                      } else {
                        opt = {
                          objectId: x[newArr[0]][newArr[1]],
                          option: x[props.schema.data.displayKey],
                        };
                      }
                    } else {
                      opt = {
                        objectId: x[newArr[0]],
                        option: x[props.schema.data.displayKey],
                      };
                    }
                  } else {
                    opt = {
                      objectId: x[props.schema.data.valueKey],
                      option: x[props.schema.data.displayKey],
                    };
                  }
                  if (opt) temp.push(opt);
                } else {
                  opt = {
                    objectId: x[props.schema.data.valueKey],
                    option: x[props.schema.data.displayKey],
                  };
                  temp.push(opt);
                }
              });
              response = temp;
              setState({ [`${props.name}_DD`]: response });
              setIsLoading(false);
              if (response.length === 1) {
                props.onChangeLevel2Dropdown(response[0].objectId, props.name);
                props.onChange(response[0].objectId);
              } else if (response.length === 0) {
                props.onChangeLevel2Dropdown("", props.name);
                props.onChange("");
              }
            })
            .catch((err) => {
              setIsLoading(false);
              setToastDescription(err.message);
            });
        } catch (e) {
          console.error("Problem", e);
          setIsLoading(false);
          setToastDescription(e.message);
        }
      }
    }
  };

  useEffect(() => {
    var x = document.getElementById("Level_2");
    x.className = "show";
    setTimeout(function () {
      x.className = x.className.replace("show", "");
    }, 5000);

    // eslint-disable-next-line
  }, [toastDescription]);

  const uniqueParentId = (id) => {
    /*  if (parentId !== id) {
      setParentId(id); */
    Level1DropdownData(id);
    // }
  };

  useEffect(() => {
    if (
      props.Level1_Dropdown[props.schema.parent] &&
      props.Level1_Dropdown[props.schema.parent] !== "undefined" &&
      props.Level1_Dropdown[props.schema.parent] !== "Select"
    ) {
      uniqueParentId(props.Level1_Dropdown[props.schema.parent]);
    } else if (
      props.Level1_Dropdown[props.schema.parent] === "" ||
      props.Level1_Dropdown[props.schema.parent] === "Select"
    ) {
      props.onChangeLevel2Dropdown("", props.name);
      setState({
        [`${props.name}_DD`]: [],
      });
    }

    // eslint-disable-next-line
  }, [props.Level1_Dropdown[props.schema.parent]]);

  useEffect(() => {
    if (props.formData && props.formData[`objectId`]) {
      if (props.formData["objectId"] !== propsId) {
        setPropsId(props.formData[`objectId`]);
        props.onChangeLevel2Dropdown(props.formData.objectId, props.name);
      }
    } else if (props.formData) {
      if (props.formData !== propsId)
        props.onChangeLevel2Dropdown(props.formData, props.name);
    }

    // eslint-disable-next-line
  }, [props.formData]);

  const selectDefault = () => {
    props.onChange(state[`${props.name}_DD`][0].objectId);
    props.onChangeLevel1Dropdown(
      state[`${props.name}_DD`][0].objectId,
      props.name
    );
  };

  return (
    <>
      <LabelField
        Title={props.schema.title}
        Name={props.name}
        Required={props.required}
        HelpBody={props.schema.data.helpbody}
        HelpLink={props.schema.data.helplink}
      />
      {state[`${props.name}_DD`] && state[`${props.name}_DD`].length === 1 ? (
        <select
          className="form-control"
          name={props.name}
          value={props.value}
          required={props.required}
          disabled={props.uiSchema["ui:disabled"]}
          onChange={(e) => {
            props.onChangeLevel2Dropdown(e.target.value, props.name);
            return props.onChange(e.target.value);
          }}
          defaultValue={selectDefault}
        >
          <option value="">Select</option>
          {state[`${props.name}_DD`] &&
            state[`${props.name}_DD`].map((x, i) => (
              <React.Fragment key={i}>
                {props.formData && props.formData.objectId ? (
                  props.formData.objectId === x.objectId ? (
                    <option value={x.objectId} selected>
                      {x.option}
                    </option>
                  ) : (
                    <option value={x.objectId}>{x.option}</option>
                  )
                ) : props.formData && props.formData === x.objectId ? (
                  <option value={x.objectId} selected>
                    {x.option}
                  </option>
                ) : (
                  <option value={x.objectId}>{x.option}</option>
                )}
              </React.Fragment>
            ))}
        </select>
      ) : (
        <select
          className="form-control"
          name={props.name}
          value={props.value}
          required={props.required}
          disabled={props.uiSchema["ui:disabled"]}
          onChange={(e) => {
            props.onChangeLevel2Dropdown(e.target.value, props.name);
            return props.onChange(e.target.value);
          }}
        >
          <option value="">{!isLoading ? "Select" : "Loading..."}</option>
          {state[`${props.name}_DD`] && state[`${props.name}_DD`].length === 1
            ? state[`${props.name}_DD`].map((x, i) => (
                <option value={x.objectId} selected>
                  {x.option}
                </option>
              ))
            : state[`${props.name}_DD`] &&
              state[`${props.name}_DD`].map((x, i) => (
                <React.Fragment key={i}>
                  {props.formData && props.formData.objectId ? (
                    props.formData.objectId === x.objectId ? (
                      <option value={x.objectId} selected>
                        {x.option}
                      </option>
                    ) : (
                      <option value={x.objectId}>{x.option}</option>
                    )
                  ) : props.formData && props.formData === x.objectId ? (
                    <option value={x.objectId} selected>
                      {x.option}
                    </option>
                  ) : (
                    <option value={x.objectId}>{x.option}</option>
                  )}
                </React.Fragment>
              ))}
        </select>
      )}
      <div id="Level_2" style={{ backgroundColor: toastColor }}>
        {toastDescription}
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    Level1_Dropdown: state.Level1_Dropdown,
  };
};

export default connect(mapStateToProps, {
  onChangeLevel2Dropdown,
})(Level2Dropdown);
